import { loyaltyConstants } from "./types";

const initialState = { addedMember: false, addingMember: false };

export default (state = initialState, action) => {
  switch (action.type) {
    case loyaltyConstants.ADD_MEMBER_REQUEST:
      return {
        ...state,
        addingMember: true,
        addedMember: false
      };
    case loyaltyConstants.ADD_MEMBER_SUCCESS:
      return {
        ...state,
        addingMember: false,
        addedMember: true
      };
    case loyaltyConstants.REFERENCES_LIST_REQUEST:
      return {
        ...state,
        ...action.payload
      };
    case loyaltyConstants.REFERENCES_LIST_SUCCESS:
      return {
        ...state,
        ...action.payload
      };
    case loyaltyConstants.CLEAR_SUCCESS_MESSAGE:
      return {
        ...state,
        addedMember: false
      };
    case loyaltyConstants.LOYALTY_ERROR:
      return {};
    default:
      return state;
  }
};
